import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button } from "antd";
import Input from "Components/UI/Input";
import { useGetAdditionsQuery } from "../../../../AppQuries/payroll/addition/get-all-additions";
import { PlusCircle, Trash2 } from "react-feather";
import { Spin, Alert } from "antd";
import dayjs from "dayjs";
import { format } from "date-fns";

const Allowance = () => {
  const {
    setValue,
    watch,
    formState: { errors },
    trigger,
    control,
  } = useFormContext();

  const {
    data: allowance,
    isLoading,
    isError,
    error,
  } = useGetAdditionsQuery({
    companyCode: watch("companyCode"),
  });

  const allowanceData = Array.isArray(allowance?.data)
    ? allowance?.data
        // .filter((data) => data.isActive === true)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];

  const allowanceDetails = watch("allowanceDetails") || [];

  const addAllowance = () => {
    const newAllowance = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      description: "",
      haveCPF: false,
      isTaxPayable: false,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      isActive: true,
      amount: "",
      effectiveDateFrom: null,
      effectiveDateTo: null,
      departmentCode: watch("departmentCode"),
      isEditable: true,
      isTemporary: false,
      projectCode: "",
    };
    setValue("allowanceDetails", [...allowanceDetails, newAllowance]);
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "allowanceDetails",
    keyName: "id",
  });

  const selectAllowanceHandler = (e, index) => {
    const selectedAllowance = allowance?.data?.find((d) => d.code === e);

    if (selectedAllowance) {
      setValue(`allowanceDetails[${index}].code`, selectedAllowance.code);
      setValue(
        `allowanceDetails[${index}].description`,
        selectedAllowance.description
      );
      setValue(
        `allowanceDetails[${index}].isTaxPayable`,
        selectedAllowance.isTaxPayable
      );
      setValue(`allowanceDetails[${index}].haveCpf`, selectedAllowance.haveCpf);
    }
    trigger(`allowanceDetails[${index}].code`);
    trigger(`allowanceDetails[${index}].description`);
  };

  if (isLoading) return <Spin spinning={isLoading} />;
  if (isError) return <Alert type="warning" message={error.message} />;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm"
          type="button"
          onClick={addAllowance}
        >
          <PlusCircle className="me-2" />
          Add Allowance
        </button>
      </div>
      <div className="table-responsive mb-3" style={{ minHeight: "300px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Allowance Name</th>
              <th>Amount</th>
              {/* <th>Effective From</th>
              <th>Effective To</th> */}
            </tr>
          </thead>
          <tbody>
            {/* {watch("allowanceDetails")?.map((_, index) => ( */}
            {fields.map(
              (field, index) =>
                !field.isTemporary && (
                  <tr key={field.id}>
                    <td>
                      <Button
                        type="danger"
                        onClick={() => remove(index)}
                        disabled={!field.isEditable}
                      >
                        <Trash2 />
                      </Button>
                    </td>
                    <td className="form-floating">
                      <Input
                        name={`allowanceDetails[${index}].code`}
                        type="commonSelect"
                        className={`form-control ${
                          errors.allowanceDetails?.[index]?.code
                            ? "is-invalid"
                            : ""
                        }`}
                        options={allowanceData}
                        placeholder="Select Allowance"
                        onSelect={(e) => selectAllowanceHandler(e, index)}
                        value={
                          allowanceData.find(
                            (option) =>
                              option.value ===
                              watch(`allowanceDetails[${index}].code`)
                          ) || {}
                        }
                        readOnly={!`allowanceDetails[${index}].isEditable`}
                      />
                    </td>
                    <td>
                      <Input
                        name={`allowanceDetails[${index}].amount`}
                        label=""
                        className={`form-control ${
                          errors.allowanceDetails?.[index]?.amount
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder=""
                        type="number"
                        required={false}
                        labelClassName=""
                        requiredMessage="This field is required"
                        readOnly={!`allowanceDetails[${index}].isEditable`}
                        // defaultValue={
                        //   watch(`allowanceDetails[${index}].amount`) || 0
                        // }
                      />
                    </td>
                    {/* <td>
                      <Input
                        name={`allowanceDetails[${index}].effectiveDateFrom`}
                        type="date"
                        placeholder="Select Effective From Date"
                        className={`form-control ${
                          errors.allowanceDetails?.[index]?.effectiveDateFrom
                            ? "is-invalid"
                            : ""
                        }`}
                        label=""
                        labelClassName="form-label"
                        required={false}
                        requiredMessage=""
                        defaultValue={
                          watch(
                            `allowanceDetails[${index}].effectiveDateFrom`
                          ) || null
                        }
                        dateFormat="YYYY-MM-DD"
                        disabledDate={(current) => {
                          return (
                            current < dayjs().subtract(1, "day").endOf("day")
                          );
                        }}
                        readOnly={!`allowanceDetails[${index}].isEditable`}
                      />
                    </td>

                    <td>
                      <Input
                        name={`allowanceDetails[${index}].effectiveDateTo`}
                        type="date"
                        placeholder="Select Effective To Date"
                        className={`form-control ${
                          errors.allowanceDetails?.[index]?.effectiveDateTo
                            ? "is-invalid"
                            : ""
                        }`}
                        label=""
                        labelClassName="form-label"
                        required={false}
                        requiredMessage=""
                        defaultValue={
                          watch(`allowanceDetails[${index}].effectiveDateTo`) ||
                          null
                        }
                        dateFormat="YYYY-MM-DD"
                        disabledDate={(current) => {
                          const effectiveDateFrom = dayjs(
                            watch("effectiveDateFrom")
                          );
                          return (
                            current < dayjs().subtract(1, "day").endOf("day") ||
                            current < effectiveDateFrom
                          );
                        }}
                        readOnly={!`allowanceDetails[${index}].isEditable`}
                      />
                    </td> */}
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Allowance;
